import { Box, Pagination } from '@mui/material';
import { vehiclePageStyles } from '../../styles';
import { PictureTile } from './PictureTile';
import { PictureToDisplay } from '../utils/pictureUtils';

interface PictureGridProps {
  paginatedPictures: PictureToDisplay[];
  selectedPictureIds: Set<string>;
  startIndex: number;
  currentPage: number;
  totalPages: number;
  isMobile: boolean;
  canEditPictures?: boolean;
  onPictureClick: (index: number) => void;
  onToggleSelection: (pictureId: string, event?: React.MouseEvent) => void;
  onPageChange: (page: number) => void;
  onAddPictures?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const PictureGrid: React.FC<PictureGridProps> = ({
  paginatedPictures,
  selectedPictureIds,
  startIndex,
  currentPage,
  totalPages,
  isMobile,
  canEditPictures = true,
  onPictureClick,
  onToggleSelection,
  onPageChange,
  onAddPictures,
}) => {
  return (
    <>
      <Box sx={vehiclePageStyles.picturesGrid}>
        {/* First picture - spans 3 rows and 3 columns */}
        <PictureTile
          picture={paginatedPictures.length > 0 ? paginatedPictures[0] : undefined}
          isSelected={paginatedPictures.length > 0 && selectedPictureIds.has(paginatedPictures[0].id)}
          isMainTile
          canEditPictures={canEditPictures}
          onPictureClick={() => {
            if (paginatedPictures.length > 0) {
              onPictureClick(startIndex);
            }
          }}
          onCheckboxClick={e => {
            if (paginatedPictures.length > 0) {
              onToggleSelection(paginatedPictures[0].id, e);
            }
          }}
          onAddPictures={onAddPictures}
          showAddButton={paginatedPictures.length === 0 && canEditPictures}
        />

        {/* Remaining pictures - 6 on mobile (2 rows × 3 columns), 12 on desktop (4 rows × 3 columns) */}
        {Array.from({ length: isMobile ? 6 : 12 }).map((_, index) => {
          const paginatedIndex = index + 1;
          const picture = paginatedPictures[paginatedIndex];
          const absoluteIndex = startIndex + paginatedIndex;

          return (
            <PictureTile
              key={picture ? picture.id : `placeholder-${index}`}
              picture={picture}
              isSelected={picture ? selectedPictureIds.has(picture.id) : false}
              canEditPictures={canEditPictures}
              onPictureClick={() => {
                if (picture) {
                  onPictureClick(absoluteIndex);
                }
              }}
              onCheckboxClick={e => {
                if (picture) {
                  onToggleSelection(picture.id, e);
                }
              }}
            />
          );
        })}
      </Box>

      {/* Pagination */}
      {totalPages > 1 && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            padding: '0 0 20px 0',
          }}
        >
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={(_, page) => onPageChange(page)}
            color="primary"
            size={isMobile ? 'small' : 'medium'}
            siblingCount={0}
            boundaryCount={1}
          />
        </Box>
      )}
    </>
  );
};
